import Passport from "assets/images/passport.png";
import TesseraSanitaria from "assets/images/tessera-sanitaria.png";
import BftButton from "common/components/button";
import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { useEffect } from "react";
import { Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { invitationSetShowHeader } from "../_redux/actions";
import { invitationInvitationSelector } from "../_redux/selectors";

const WelcomePage: React.FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const invitation = useAppSelector(invitationInvitationSelector);

	const goNext = () => {
		navigate(AppRouterService.get(PathEnum.identification));
	};

	useEffect(() => {
		dispatch(invitationSetShowHeader(false));
	}, []);

	const CustomCard: React.FC<{
		image: string;
		title: string;
		subtitle: string;
	}> = ({ image, title, subtitle }) => {
		return (
			<Card className="custom-card shadow">
				<Card.Img variant="top" src={image} />
				<Card.Body>
					<div className="text-left pt-1">
						<h5>{title}</h5>
						<span className="gray font-weight-bold m-0">
							<small>{subtitle}</small>
						</span>
					</div>
				</Card.Body>
			</Card>
		);
	};

	return (
		<div>
			<section className="welcome-page text-center">
				<div className="mb-5">
					<h2 className="mb-3">
						Ciao, {invitation?.firstName} {invitation?.lastName}
					</h2>

					<span className="gray">
						Sei invitato da{" "}
						<b>
							{invitation?.rappLegaleFirstName} {invitation?.rappLegaleLastName}
						</b>
						{", "}
						legale rappresentante dell'azienda in cui operi, la <b>{invitation?.clienteDesc}</b>, a
						completare la sottoscrizione del prodotto offerto da Buffetti Finance.
						{/* {" "}<b>{invitation?.plan}</b> di Buffetti Finance. */}
					</span>
				</div>

				<h2 className="mb-3">Prima di iniziare assicurati di avere:</h2>

				<div className="cards-container">
					<CustomCard
						image={Passport}
						title="Documento di riconoscimento"
						subtitle="Carta d'identità, patente, passaporto"
					/>
					{invitation?.checkTesseraSanitaria && (
						<CustomCard
							image={TesseraSanitaria}
							title="Tessera Sanitaria con Codice Fiscale"
							subtitle="Con ulteriore documento di identificazione."
						/>
					)}
				</div>

				<BftButton className="btn-buffetti" onClick={goNext}>
					Ho tutto, iniziamo!
				</BftButton>

				<div className="gray my-5">
					Segui le istruzioni riportate e assicurati di avere <b>tutti i documenti necessari.</b>
					<br />
					Qualora fossi in difficoltà non esitare a contattarci al numero verde <b>800.693.173</b>
				</div>

				{/* <a href="#">
				<b className="gray">Non sei tu?</b>
			</a> */}
			</section>
		</div>
	);
};
export default WelcomePage;
